import { createAction } from '@reduxjs/toolkit'
import type { IDealAgreementFileDownload } from './interfaces'

export const downloadDocument = createAction<IDealAgreementFileDownload>('@@dealAgreementForm/DOWNLOAD_DOCUMENT')
